import { render } from "./PropertyServiceTable.vue?vue&type=template&id=7aef4db3&scoped=true&ts=true"
import script from "./PropertyServiceTable.vue?vue&type=script&lang=ts"
export * from "./PropertyServiceTable.vue?vue&type=script&lang=ts"

import "./PropertyServiceTable.vue?vue&type=style&index=0&id=7aef4db3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aef4db3"]])

export default __exports__